import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth-store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isInitialized, user } = useAuthStore();

  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-app">
        <div className="text-ink-muted">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has Superadmin role
  if (!user?.roles?.includes('Superadmin')) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-app">
        <div className="max-w-md w-full bg-surface-app-elevated border border-white/10 shadow-lg rounded-lg p-8">
          <h1 className="font-display text-2xl font-semibold tracking-tight text-brand-warm mb-4">Access Denied</h1>
          <p className="text-ink-secondary mb-4">
            You do not have permission to access the admin panel.
          </p>
          <p className="text-sm text-ink-muted">
            Only users with Superadmin role can access this area.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
